import languageUtils from '$common/utils/language';
export default {
  computed: {
    lang() {
      const navigatorLanguage = languageUtils.getPageHeaderCurrentLanguage;
      return navigatorLanguage.indexOf('zh') !== -1 ? 'zh' : navigatorLanguage.indexOf('en') !== -1 ? 'en' : 'km';
      // return 'en';
      // return 'km';
    }
  }
}